import { Page } from '@models/page';
import { ProvisioningProfile } from '@models/provisioning-profile.model';
import ProvisioningProfileService from '@modules/settings/pages/ios-settings/components/ios-service';
import { Icon, PrimaryButton, useTranslation } from '@testsigma/atoms';
import { DocumentURL } from '@utils/common';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

type ProvisionSelectionComponentType = {
  setProvisonCreated: Function;
  id: number;
};

export const ProvisionSelectionComponent = (
  props: ProvisionSelectionComponentType,
) => {
  const [length, setLength] = useState<number>();
  const { t } = useTranslation();
  const fetchProvision = () => {
    ProvisioningProfileService.findAll().then(
      (data: Page<ProvisioningProfile>) => {
        setLength(data.content.length);
        if (data.content.length == 0) props.setProvisonCreated(false);
        else props.setProvisonCreated(true);
      },
    );
  };

  useEffect(() => {
    fetchProvision();
  }, []);
  const onNewProfile = () => {
    const openedWindow = window.open(
      '/ui/settings/provisioning_profiles/new/by-popup',
      '_blank',
    );
    const checkClosedInterval = setInterval(() => {
      if (!openedWindow.location.href.includes('new') || openedWindow.closed) {
        fetchProvision();
        clearInterval(checkClosedInterval);
      }
    }, 1000);
  };
  return (
    <div className='p-4 flex flex-col gap-4 border rounded-2xl border-secondary-100  bg-secondary-50'>
      <div className='flex flex-row gap-4'>
        <div className='border rounded-full w-8 h-8 bg-white flex  justify-center aspect-square'>
          <Icon name='info-fill' className='text-xl text-secondary-600' />
        </div>
        <span className='inline-flex text-xs font-normal text-secondary-unique-600'>
          {length == 0
            ? t('upload.iosapp.provisioningprofile.select.note')
            : t('upload.iosapp.provisioningprofile.existing.note')}
        </span>
      </div>
      <div
        className={
          'pl-11 flex flex-row' +
          (length == 0 ? ' justify-between' : ' justify-start')
        }>
        {length == 0 && (
          <PrimaryButton onClick={onNewProfile}>
            <span className='flex flex-row gap-1'>
              {t('upload.iosapp.provisioningprofile.createnew')}
              <Icon
                name='open-in-new'
                className='text-xs !inline-flex !items-center'
              />
            </span>
          </PrimaryButton>
        )}
        <DocumentURL path='/docs/configuration/ios-settings/' className='flex'>
          <div className='flex flex-row gap-1  text-secondary-600 text-xs'>
            <Icon name='description' />
            <span className='!inline-flex !items-center'>
              {t('upload.iosapp.provisioningprofile.createnew.learnmore')}
            </span>
          </div>
        </DocumentURL>
      </div>
    </div>
  );
};
